<script>
import { smartCarMethods } from '@state/helpers'
import { required, maxLength, helpers, minLength, minValue, alphaNum } from 'vuelidate/lib/validators'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import ConfirmModal from '@components/ConfirmModal.vue'


// import EuroCouponsItemForm from '@components/euro_coupons/item/Form'
import XLSX from 'xlsx'

const minRequired = (value) => value.length > 0 && value.length <= 1300
const someError = (items) => !items.some((item) => item.error === true)
const mustBeOption = (value) => ['1'].includes(value)

export default {
  name: 'SmartCarUploadData',
  components: { DatePicker, ConfirmModal },
  props: {
    fullform: {
      type: Boolean,
      required: false,
      default: false,
    },
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    type_action:{
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      showConfirmModal: false,
      reading: false,
      action: 'create',
      selectedFile: false,
      file: null,
      form: {
        cardholders: [
        ],
      },
      quantity: null,
      value: null,

      //Table
      fields: [
        {
          key: 'document_type',
          label: this.$t('type'),
        },
        {
          key: 'document',
          label: this.$t('document'),
        },
        {
          key: 'bin',
          label: this.$t('bin'),
        },
        {
          key: 'actions',
          label: this.$t(''),
        },
      ],
      items: [],

      documentOptions: [
        { value: '1', text: '1' }
      ],
      modelConfig: {
      },
    }
  },
  validations: {
    form: {
    },
    items: {
      minRequired,
      someError,
      $each: {
        document_type: {
          required,
          mustBeOption
        },
        document: {
          required,
          minLength: minLength(6)
        },
        bin: {
          required,
          minLength: minLength(4),
          maxLength: maxLength(8)
        },
      }
    },
  },
  computed: {},

  watch: {
    items: {
      deep: true,
      handler(values) {
        values = values.map((item, index) => {
          item['document'] = Number(item['document']
          )
          return item
        })

        this.form.cardholders = values
        this.quantity = values.length
        this.value = values.reduce((a, b) => a + b['value'], 0)
        this.reading = false
      },
    },
  },

  mounted: function () {
    let context = this
    context.form = {
      ...context.form,
      ...context.instanceJson,
    }
    // if (context.instanceJson.url) {
    //   context.action = 'update'
    //   // context.getObject()
    // } else {
      context.action = 'create'
      context.loading = false
    // }
  },

  methods: {
    ...smartCarMethods,


    tbodyRowClass(item) {
      return item.error === true ? ['table-danger'] : ''
    },
    removeItem(index) {
      this.items.splice(index, 1)
      // this.$v.items.$touch()
    },
    toggleError(index) {
      this.items[index].error = !this.items[index].error
      // this.$v.items.$touch()
    },
    dateFormat(value) {
      return value.toISOString().split('T')[0]
    },

    exportExcel() {
      const sheetToExport = [
        {
          'Tipo de Documento': null, //A
          Documento: null, //B
          Bin: null // c
        },
      ]

      const consolidatedWorkSheet = XLSX.utils.json_to_sheet(sheetToExport)

      //Cell comment 'Tipo de Documento'
      consolidatedWorkSheet.A1.c = []
      consolidatedWorkSheet.A1.c.hidden = true
      consolidatedWorkSheet.A1.c.push({
        t: 'Documentos Validos: 1, corresponde a cédula',
      })

      //Cell comment 'Documento'
      consolidatedWorkSheet.B1.c = []
      consolidatedWorkSheet.B1.c.hidden = true
      consolidatedWorkSheet.B1.c.push({
        t: 'Por favor solo ingrese números.',
      })

      //Cell comment 'Bin'
      consolidatedWorkSheet.C1.c = []
      consolidatedWorkSheet.C1.c.hidden = true
      consolidatedWorkSheet.C1.c.push({
        t: 'Ingrese el numero de Bin; mínimo 4 dígitos, máximo 8 dígitos',
      })

      const workBook = {
        SheetNames: ['data'],
        Sheets: { data: consolidatedWorkSheet },
      }

      XLSX.writeFile(workBook, 'Plantilla Bin Smart Car.xlsx')
    },

    readFile() {
      const context = this
      context.items = []
      context.reading = true
      const fileReader = new FileReader()

      const readOpts = {
        cellDates: true,
        type: 'binary',
      }

      const jsonOpts = {
        raw: false,
        cellNF: true,
      }

      fileReader.onload = async (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, readOpts)

          const wsname = workbook.SheetNames[0]
          let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], jsonOpts)

          if (ws.length >= 1301) {
            context.reading = false
            return this.$generate_toast(context, 'error', 'Demasiados registros, por favor realice cargas de máximo 1300 bines.')
          }

          if (ws.length === 0) {
            context.reading = false
            return this.$generate_toast(context, 'error', 'No hay información')
          }
          
          let tmp_items = []
          ws.forEach((bin, index) => {

            let item = {
              document_type: bin['Tipo de Documento'],
              document: Number(bin['Documento']),
              bin: Number(bin['Bin'])
            }
            tmp_items.push(item)

          })
          context.items = [...tmp_items]
        } catch (e) {
          context.reading = false
          return this.$generate_toast(context, 'error', 'Error al leer archivo')
        }
      }
      fileReader.readAsBinaryString(context.file)

    },

    importExcel(e) {
      const context = this
      const files = e.target.files
      if (!files.length) {
        return
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return context.$generate_toast(
          context,
          'error',
          'Seleccionar un archivo con formato xls o xlsx'
        )
      }
      context.file = files[0]
      context.selectedFile = true
      // this.readFile(files[0])
    },

    submit() {
      let context = this
      context.submitting = true
      let actions = {
        create: context.manualCreateEuroSmartCarCardholders,
        delete: context.manualDeleteEuroSmartCarCardholders
      }
      const promise = actions[context.type_action](context.form)
      return promise
        .then((response) => {
          let data = response.data
          if (response.status !== 206) {
            context.$generate_toast(
              context,
              'success',
              `${context.$t('request_cardholders')} ${
                context.$t('created')
              } ${context.$t('correctly')}`
            )
            setTimeout(() => {
              context.oncomplete(data.url || null)
              context.submitting = false
              context.showConfirmModal = false
            }, 2000)
          } else {
            context.$generate_toast(
              context,
              'info',
              `Algunos tarjetahabientes no fueron registrados.`
            )
            context.submitting = false
            context.showConfirmModal = false
          }
        })
        .catch((error) => {
          context.submitting = false
          context.showConfirmModal = false
          context.$axios_error_noty(error, context)
        })
    },

    errorMessage(errors=[]) {
      let context = this
      let listFields = errors.map( (error) => context.$t(error)).join(', ')
      let create_message = 'El beneficiario actualmente posee bonos asociados en los rangos de tiempo especificados.'
      let delete_message = 'No se encontró tarjetahabiente con la información especificada.'

      if (errors[0] === 'overlapping_coupons' && context.type_action == 'create'){
        return create_message
      } else if( context.type_action == 'delete') {
        delete_message
      }
      return `Los siguientes campos poseen datos inválidos: ${listFields}. `
    },

    confirmSubmit() {
      let context = this
      context.$v.form.$touch()
      context.$v.items.$touch()
      if (context.$v.form.$invalid || context.$v.items.$invalid) {
        context.submitting = false
        context.$generate_toast(
          context,
          'error',
          context.$t('fill_the_required_fields')
        )
        return
      }
      context.showConfirmModal = true
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    scrollable 
    id='upload-data-modal'
    title="Cargar Bin Smart Car"
    :size="action === 'create' ? 'xl' : 'xl'"
    @hidden="oncancel"
    @ok.prevent="confirmSubmit"
  >
    <div class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else class="m-3">
        <b-col md="12">

          <div class="mb-3">
            <b-form-group
              class="text-primary font-weight-bold"
              :label="$t('upload_data_from_file')"
            >
              <b-form-file
                class="border-primary"
                ref="excel_user_file"
                :placeholder="$t('select_file')"
                :drop-placeholder="$t('select_file')"
                :browse-text="$t('search')"
                @change="importExcel"
              />

            </b-form-group>
            <b-button
              variant="secondary rounded"
              class="mr-2"
              @click="exportExcel"
            >
              <i class="fas fa-file-excel"></i>
              {{ $t('download_template') }}
            </b-button>
            <b-button
              variant="primary rounded"
              :disabled="!selectedFile || submitting || reading"
              @click="readFile"
            >
            <b-spinner v-if="reading" label="Spinning" small></b-spinner>
            <i v-else class="fas fa-file-import"></i>
            <span> {{ reading ? 'Procesando' : $t('process_file') }} </span>
            </b-button>
          </div>


        </b-col>
        <b-col class="mt-3">
          <div>
            <!-- <pre>{{ items  }}</pre> -->
            <h5>Vista previa Bin asociados </h5>

            <div
              v-if="!$v.items.someError && $v.items.minRequired"
              class="alert alert-danger"
              role="alert"
            >


            {{ type_action === 'create' ? 'Los beneficiarios resaltados actualmente poseen datos inconsistentes': 'Los bonos resaltados no fueron encontrados' }}
              <span class="alert-link">actualice la información y verifique o elimínelos.</span
              >
            </div>

            <b-table
              v-if="items.length"
              hover
              small
              :items="items"
              :fields="fields"
              responsive
              :thead-class="['text-primary', 'border-primary']"
              :tbody-tr-class="tbodyRowClass"
            >
              <template #cell(document_type)="row">
                <b-form-select
                  style="min-width: 80px"
                  v-model="row.item.document_type"
                  :options="documentOptions"
                  :state="!$v.items.$each[row.index].document_type.$invalid"
                  v-b-tooltip.focus="{ variant: $v.items.$each[row.index].document_type.$invalid ? 'danger' : 'success' }"
                  :title="$v.items.$each[row.index].document_type.$invalid ? 'Seleccione una opción valida': 'campo valido'"
                >
                </b-form-select>
              </template>
              <template #cell(document)="row">
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="row.item.document"
                  :formatter="(value) => Number(value)"
                  :state="!$v.items.$each[row.index].document.$invalid"
                  v-b-tooltip.focus="{ variant: $v.items.$each[row.index].document.$invalid ? 'danger' : 'success' }"
                  :title="$v.items.$each[row.index].document.$invalid ? 'Obligatorio, debe tener mínimo 6 dígitos.': 'campo valido'"
                />
              </template>
              <template #cell(bin)="row">
                <b-form-input
                  size="sm"
                  type="number"
                  v-model="row.item.bin"
                  :formatter="(value) => Number(value)"
                  :state="!$v.items.$each[row.index].bin.$invalid"
                  v-b-tooltip.focus="{ variant: $v.items.$each[row.index].bin.$invalid ? 'danger' : 'success' }"
                  :title="$v.items.$each[row.index].bin.$invalid ? 'Obligatorio, debe tener mínimo 4 dígitos y máximo 8 dígitos.': 'campo valido'"
                />
              </template>
              <template #cell(actions)="row">
                <div style="min-width: 75px">
                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    @click="
                      () => {
                        removeItem(row.index)
                      }
                    "
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                  <b-button
                  v-if="row.item.errors && row.item.error"
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: errorMessage(row.item.errors),
                    }"
                    variant="btn-link text-danger btn-transparent mx-1"
                  >
                  <i class="fas fa-exclamation-circle"></i>
                  </b-button>
                  <b-button
                    v-if="row.item.error"
                    :id="`check-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'success',
                      placement: 'top',
                      title: 'De clic para indicar que el registro fue corregido.',
                    }"
                    variant="btn-link text-success btn-transparent"
                    @click="
                      () => {
                        toggleError(row.index)
                      }
                    "
                  >
                    <i class="far fa-calendar-check"></i>
                  </b-button>
                </div>
              </template>
              <template #custom-foot>
                <b-tr>
                  <b-td
                    colspan="3"
                    class="text-primary font-weight-bold text-right"
                    style="border-top: solid 1px"
                    ><span>Total</span></b-td
                  >
                  <b-td
                    class="border-primary text-center"
                    style="border-top: solid 1px"
                    >{{ $formatDollar(quantity) }}</b-td
                  >
                </b-tr>
              </template>
            </b-table>
          </div>
          <div
            v-if="!$v.items.minRequired"
            class="alert alert-danger"
            role="alert"
          >
            La solicitud debe tener
            <span class="alert-link"> al menos un registro y máximo 1300</span>.
          </div>
        </b-col>
      </b-row>
    </div>

    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="outline-primary" class="rounded-lg" @click="cancel">
        Cancelar
      </b-button>

      <b-button
        :variant=" type_action === 'create' ? 'primary' : 'danger'"
        class="rounded-lg"
        :disabled="!$v.items.minRequired"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> {{ type_action === 'create' ? $t('saving') : $t('deleting') }} </span>
        <span v-else>
          <i :class="{'fe-save': type_action === 'create',
          'far fa-trash-alt': type_action === 'delete'}"></i>
          {{ type_action === 'create' ? $t('create') : $t('delete') }}
        </span>
      </b-button>
    </template>
    <ConfirmModal
      v-if="showConfirmModal"
      :close-modal="
        () => {
          showConfirmModal = false
        }
      "
      :on-submit="submit"
      :submitting="submitting"
      :warningMessage="`¿Esta seguro de ${ type_action === 'create' ? $t('create') : $t('delete') } los registros con la información indicada?`"
    />
  </b-modal>
</template>
<style lang="scss">

#upload-data-modal .modal-dialog {
    max-width: 95%;
    height: 95vh;
    display: flex;
}
</style>